/** 合同账号由公司资料自动匹配，页面只展示结果，不再让工程人员填写或分配登录账号。
 * 打开已有合同也会补齐关联；切换合同/公司时丢弃旧响应，失败可重试，不伪装为“未开户”。
 */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { detailToText } from "../../lib/detailText";

const MESSAGES = {
  no_account: ['该公司尚未开通账号，请到分包商管理开通。', 'This company has no account. Create one in Subcontractors.'],
  account_disabled: ['关联账号不可用，请到分包商管理检查账号状态。', 'The account is unavailable. Check its status in Subcontractors.'],
  company_missing: ['请先从公司库选择分包商。', 'Choose a subcontractor from the company directory.'],
  company_disabled: ['该公司已停用，请到分包商管理检查。', 'This company is inactive. Check it in Subcontractors.'],
  ambiguous_company: ['存在同名公司，请从公司库选择具体公司。', 'Multiple companies share this name. Choose the company from the directory.'],
  ambiguous_account: ['该公司有多个可用账号，请到分包商管理核对账号关联。', 'This company has multiple accounts. Review the account links in Subcontractors.'],
  company_mismatch: ['合同账号与所选公司不一致，请到分包商管理核对。', 'The account belongs to a different company. Review it in Subcontractors.'],
  signing_locked: ['合同正在签署，当前签署人保持不变。', 'Signing is in progress. The current signer is unchanged.'],
  closed: ['合同已关闭。', 'This contract is closed.'],
};

/** sc 是当前合同，reload 刷新父级业务数据；仅在服务器确认绑定后刷新签署/整改等操作。 */
export function SubcontractAccountStatus({ sc, api, zh, reload }) {
  const [result, setResult] = useState(null), [error, setError] = useState(''), [attempt, setAttempt] = useState(0);
  const reloadRef = useRef(reload);
  reloadRef.current = reload;
  useEffect(() => {
    let live = true;
    setResult(null); setError('');
    api.post(`/subcontracts/${sc.id}/auto-bind-account`).then(({ data }) => {
      if (!live) return;
      setResult(data);
      if (data.changed) reloadRef.current();
    }).catch(e => {
      if (live) setError(detailToText(e.response?.data?.detail) || (zh ? '自动绑定失败，请重试。' : 'Automatic linking failed. Please retry.'));
    });
    return () => { live = false; };
  }, [api, sc.id, sc.subcontractorCompanyId, sc.companyId, sc.vendorId, sc.subcontractorName, sc.subcontractorUserId, sc.signing?.status, sc.status, attempt, zh]);
  const message = result && MESSAGES[result.status];
  return <div className="space-y-1 text-xs" data-testid={`sub-account-status-${sc.id}`}>
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1" role="status" aria-live="polite">
      <span className="text-muted-foreground">{zh ? '分包商账号' : 'Account'}:</span>
      <span className="font-medium text-foreground break-all">{result?.username || sc.subcontractorUserId || (result || error ? (zh ? '未绑定' : 'Not linked') : (zh ? '正在自动绑定…' : 'Linking automatically…'))}</span>
      {result?.status === 'bound' && <span className="text-muted-foreground">{zh ? '已绑定' : 'Linked'}</span>}
    </div>
    {message && <p className="text-muted-foreground">{message[zh ? 0 : 1]}{!['signing_locked', 'closed'].includes(result.status) && <Link to="/subcontractor-companies" className="ml-2 text-primary underline rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{zh ? '分包商管理' : 'Subcontractors'}</Link>}</p>}
    {error && <div className="flex flex-wrap items-center gap-2"><p role="alert" className="text-destructive">{error}</p><Button variant="outline" size="sm" onClick={() => setAttempt(a => a + 1)}>{zh ? '重试' : 'Retry'}</Button></div>}
  </div>;
}
